import { useQuery } from '@apollo/client';

import type {
  EmbeddedSourceCourseAttributionQuery,
  EmbeddedSourceCourseAttributionQueryVariables,
} from 'bundles/common/lms-authoring/queries/__generated__/getCourseAndPartnerDataById';
import getCourseAndPartnerDataById from 'bundles/common/lms-authoring/queries/getCourseAndPartnerDataById.graphql';

export const useGetEmbeddedSourceCourseQuery = (sourceCourseId: string, skip?: boolean) => {
  const { data, loading, error } = useQuery<
    EmbeddedSourceCourseAttributionQuery,
    EmbeddedSourceCourseAttributionQueryVariables
  >(getCourseAndPartnerDataById, {
    variables: { courseId: sourceCourseId },
    skip: !!skip,
    context: {
      clientName: 'gatewayGql',
    },
  });

  return { sourceCourse: data?.Course?.queryBasicInfoById, loading, error };
};
